// src/components/ConversationPreview.js
import React from "react";
import styled from "styled-components";
import ExclamationMark from "./ExclamationMark";
import axios from "../axiosConfig";

const ConversationPreview = ({ conversation, onClick }) => {
  const lastMessage = conversation.messages[conversation.messages.length - 1];


  const handleEndConversation = async (e) => {
    e.stopPropagation(); // Prevent the Container onClick event from firing
    try {
      const response = await axios.post(`/conversations/${conversation.thread_id}/end`);
      if (response.status === 200) {
        conversation.active = false;
      }
    } catch (err) {
      console.error("Failed to end conversation", err);
    }
  };

  const isActiveAndRequiresAction =
    conversation.requires_action === true && conversation.active === true;

  return (
    <Container
      onClick={() => onClick(conversation)}
      requiresAction={conversation.requires_action === true}
      isActiveAndRequiresAction={isActiveAndRequiresAction}
    >
      <ProfilePicture src="/user.png" alt="Profile" />
      <Details>
        <Username>{conversation.username}</Username>
        <LastMessage>{lastMessage.content}</LastMessage>
        {conversation.requires_action && (
          <ExclamationMark
            reason={conversation.reason_for_action}
            isActiveAndRequiresAction={isActiveAndRequiresAction}
          />
        )}
      </Details>
      <EndButton
        onClick={handleEndConversation}
        disabled={!conversation.active}
      >
        Finalizar
      </EndButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  margin: 10px;
  border-radius: 5px;
  background-color: ${(props) =>
    props.isActiveAndRequiresAction ? "#d9fdd3" : "#fff"};
  &:hover {
    background-color: ${(props) =>
      props.requiresAction ? "#b5d4b0" : "#d4d5d6"};
  }
`;

const ProfilePicture = styled.img.attrs((props) => ({
  src: props.src,
  onError: (e) => {
    e.target.onerror = null;
    e.target.src = "/user.png";
  },
}))`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
`;

const Details = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Username = styled.div`
  font-weight: bold;
`;

const LastMessage = styled.div`
  color: #888;
`;

const EndButton = styled.button`
  background-color: #ff4c4c;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #ff3333;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export default ConversationPreview;
